import { render } from "./fast-forward.vue?vue&type=template&id=759dd7be"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/fast-forward.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "759dd7be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('759dd7be', __exports__)) {
    api.reload('759dd7be', __exports__)
  }
  
  module.hot.accept("./fast-forward.vue?vue&type=template&id=759dd7be", () => {
    api.rerender('759dd7be', render)
  })

}


export default __exports__